import { useInfiniteQuery } from '@tanstack/react-query';
import type { DeviceGenre } from '@/constants/device';
import { getDeviceCatalogsForSelect } from './api';
import { deviceCatalogsForSelect } from './key';
import { convertToDeviceCatalogOption } from './selector';
import type { DeviceCatalogOption } from './selector';
export const useDeviceCatalogsForSelect = (searchText: string, genre?: DeviceGenre, enabled = true) => {
  const query = useInfiniteQuery({
    queryKey: deviceCatalogsForSelect.catalogs(searchText, genre ? [genre] : undefined),
    queryFn: ({
      pageParam
    }) => getDeviceCatalogsForSelect(searchText, pageParam, {
      genres: genre ? [genre] : undefined
    }),
    enabled,
    initialPageParam: 1,
    getNextPageParam: (lastPage, _allPages, lastPageParam) => {
      if (lastPageParam >= lastPage.maxPage) {
        return undefined;
      }
      return lastPageParam + 1;
    },
    select: data => {
      const options = data.pages.flatMap(page => page.items.map(convertToDeviceCatalogOption));
      return options;
    }
  });
  return {
    ...query,
    data: query.data ?? []
  };
};

/**
 * useDeviceCatalogsForSelect の戻り値型
 * 依存性注入パターンで使用
 */
export type UseDeviceCatalogsForSelectResult = ReturnType<typeof useDeviceCatalogsForSelect>;

/**
 * デバイスカタログ取得 Hook の型
 * 依存性注入パターンで使用
 */
export type UseDeviceCatalogsForSelect = (searchText: string, genre?: DeviceGenre, enabled?: boolean) => UseDeviceCatalogsForSelectResult;
export type { DeviceCatalogOption };